import Route from '@ember/routing/route';

export default class UnauthorizedRoute extends Route {}
